import { Component, OnInit, HostListener, AfterViewInit, OnDestroy, EventEmitter } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { Router, RouterOutlet } from '@angular/router';

import { AdminService } from '../_services/admin/admin.service';
import { ContextAdmin } from '../_models/admin/context.admin';
import { MenuItem } from '../_models/admin/menu.item';
import { AuthService } from '../_services/auth.service';
import { MainService } from '../_services/main.service';
import { ResizeInfo } from '../_models/common/resize.info';
import { RouteAnimations } from '../_animations/route.animations';
import { WholesalerModel } from '../_models/common/wholesaler.model';
import { HotkeyService } from 'app/_services/hotkey.service';
import { HotkeyModifierKeyKind } from 'app/_models/admin/hotkey.modifier.key.kind';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  animations: RouteAnimations
})
export class AdminComponent implements OnInit, AfterViewInit, OnDestroy {
  ctx: ContextAdmin;
  activeMenuId: number;
  search: string;
  searchRegex: RegExp;
  year: number = new Date().getFullYear();
  intervalSubscription: Subscription;
  wholesalerChange: EventEmitter<WholesalerModel> = new EventEmitter<WholesalerModel>();
  chooseWholesalerHotkey: EventEmitter<KeyboardEvent[]> = new EventEmitter<KeyboardEvent[]>();
  menuItemHotkeys: { [key: string]: EventEmitter<KeyboardEvent[]> } = {};

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.mainService.onResize(new ResizeInfo(document.body.clientWidth, document.body.clientHeight, 0, 0, 0));
  }

  constructor(
    public mainService: MainService,
    public adminService: AdminService,
    public authService: AuthService,
    private hotkeyService: HotkeyService,
    private router: Router
  ) { }

  ngOnInit() {
    this.adminService.getContext(true)
      .subscribe((ctx: ContextAdmin) => {
        this.ctx = ctx;
        this.setHotKeys(this.ctx.Menu);
      });

    this.intervalSubscription = interval(60 * 1000)
      .subscribe(() => this.adminService.updateOnlineSessionCount());

    this.wholesalerChange
      .subscribe(wholesaler => this.adminService.setCurrentWholesaler(wholesaler));

    this.hotkeyService.addHotkeyEvent('chooseWholesalerHotkey', this.chooseWholesalerHotkey);
    this.chooseWholesalerHotkey.subscribe(eventPair => {
      const [event, lastEvent] = eventPair;
      if (this.adminService.superAdmin && event.shiftKey && event.ctrlKey && !event.altKey && event.key === 'G') {
        console.info(`Kies grossier...`);
        this.authService.chooseWholesaler(null, this.ctx.Wholesalers, this.wholesalerChange, false)
      }
    });
  }

  ngAfterViewInit() {
    // wait a tick to avoid one-time devMode
    // unidirectional-data-flow-violation error
    const self = this;
    setTimeout(_ => {
      self.mainService.onResize(new ResizeInfo(document.body.clientWidth, document.body.clientHeight, 0, 0, 0));
    }, 500);
  }

  ngOnDestroy() {
    this.hotkeyService.removeHotkeyEvent('chooseWholesalerHotkey');
    this.removeHotKeys();
    this.intervalSubscription.unsubscribe();
  }

  setHotKeys(menuItems: MenuItem[]) {
    menuItems.forEach(menuItem => {
      if (menuItem.Hotkeys && menuItem.Hotkeys.length > 0) {
        const hotkeyEmitter = new EventEmitter<KeyboardEvent[]>();
        this.hotkeyService.addHotkeyEvent(`menuItemHotkey_${menuItem.ID}`, hotkeyEmitter);
        this.menuItemHotkeys[`menuItemHotkey_${menuItem.ID}`] = hotkeyEmitter;

        // Capture menuItem in closure to avoid reference issues
        const capturedMenuItem = menuItem;
        hotkeyEmitter.subscribe(events => {
          let match = true;
          capturedMenuItem.Hotkeys.forEach((hotkey, index) => {
            const eventIndex = capturedMenuItem.Hotkeys.length - 1 - index;
            if (eventIndex >= events.length) match = false;
            if (match && (hotkey.ModifierKeys & HotkeyModifierKeyKind.AltKey) !== 0 && !events[eventIndex].altKey) match = false;
            if (match && (hotkey.ModifierKeys & HotkeyModifierKeyKind.CtrlKey) !== 0 && !events[eventIndex].ctrlKey) match = false;
            if (match && (hotkey.ModifierKeys & HotkeyModifierKeyKind.ShiftKey) !== 0 && !events[eventIndex].shiftKey) match = false;
            if (match && (hotkey.ModifierKeys & HotkeyModifierKeyKind.MetaKey) !== 0 && !events[eventIndex].metaKey) match = false;
            if (match && hotkey.Key && hotkey.Key.toUpperCase() !== events[eventIndex].key.toUpperCase()) match = false;
          });
          if (match) {
            console.info(`Hotkey for menu item '${capturedMenuItem.Title}' activated.`);
            this.activeMenuId = capturedMenuItem.ID;
            this.router.navigate(['/admin/' + capturedMenuItem.Route]);
          }
        });
      }
      if (menuItem.SubMenu && menuItem.SubMenu.length > 0) {
        this.setHotKeys(menuItem.SubMenu);
      }
    });
  }

  removeHotKeys() {
    Object.keys(this.menuItemHotkeys).forEach(key => {
      this.hotkeyService.removeHotkeyEvent(key);
    });
    this.menuItemHotkeys = {};
  }

  prepareRoute(outlet: RouterOutlet) {
    // return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  searchChanged(search: string) {
    if (search) {
      this.searchRegex = new RegExp(search, 'i');
    } else {
      this.searchRegex = null;
    }
  }

}
